import React from "react";
import PropTypes from "prop-types";
import RichText from "../Prismic/RichText";
import isEmpty from "lodash/isEmpty";
import TextHero from "wonderbly-components/lib/TextHero";
import useGlobalContent from "../../hooks/use-global-content";

const RangeHero = (props) => {
  const { promos } = useGlobalContent();

  return (
    <TextHero
      containerClass="container-guttered"
      title={
        <RichText
          inline
          fields={[
            {
              text: props.title,
            },
          ]}
        />
      }
      body={
        props.body && (
          <RichText
            inline
            fields={[
              {
                text: props.body,
              },
            ]}
          />
        )
      }
      promoText={
        promos?.offerText && (
          <RichText
            inline
            fields={[
              {
                text: promos.offerText,
              },
            ]}
          />
        )
      }
      backgroundColor={props.backgroundColor}
      borderColor={props.borderColor}
      image={isEmpty(props.backgroundImage) ? null : props.backgroundImage}
      invert={props.invert}
    />
  );
};

RangeHero.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string,
  promoText: PropTypes.array,
  borderColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.object,
  invert: PropTypes.bool,
};

export default RangeHero;
